// Categorías FHIR compartidas por la familia de solicitud/informe del
// Anexo 1 MSP (010A/010B, 012A/012B, 013A/013B) — extraídas de
// `ordenDiagnostica.tsx` (borrado tras el reemplazo de esos 6 códigos por
// formularios propios, Tandas 2-4) porque los `ServiceRequest`/
// `DiagnosticReport` de cada uno siguen necesitando el mismo `category`.
import type { CodeableConcept } from '@medplum/fhirtypes';

export const CATEGORIA_LABORATORIO: CodeableConcept = {
  coding: [{ system: 'http://terminology.hl7.org/CodeSystem/v2-0074', code: 'LAB', display: 'Laboratory' }],
  text: 'Laboratorio Clínico',
};
export const CATEGORIA_IMAGENOLOGIA: CodeableConcept = {
  coding: [{ system: 'http://terminology.hl7.org/CodeSystem/v2-0074', code: 'RAD', display: 'Radiology' }],
  text: 'Imagenología',
};
// v2-0074 no tiene código propio para Anatomía Patológica — se usa SNOMED
// (mismo criterio pragmático que el resto del código: coding real donde
// existe un catálogo estándar limpio, sin forzar uno que no aplica).
export const CATEGORIA_ANATOMIA_PATOLOGICA: CodeableConcept = {
  coding: [{ system: 'http://snomed.info/sct', code: '396540009', display: 'Histopathology test' }],
  text: 'Anatomía Patológica',
};
